import React, { useEffect, useState } from 'react';
import {
  IonContent,
  IonLabel,
  IonItem,
  IonInput,
  IonButton,
  IonItemDivider,
} from '@ionic/react';
import { Farecard } from '../../services/types/apitypes';
import { useTranslation } from 'react-i18next';
import './CardInformation.css';
import { uiInputMode } from '../../utils/ui';
import { currencyFormatNoSpace } from '../../utils/currency';
import { formatCreditCard } from '../../utils/strings';

type CardInformationProps = {
  card: Farecard | undefined;
  onSubmit: (nickname: string) => void;
};

const CardInformation: React.FC<CardInformationProps> = ({
  card,
  onSubmit,
}) => {
  const [inputValue, setInputValue] = useState(card?.nickname || '');
  const [t] = useTranslation('global');

  useEffect(() => {
    if (card?.nickname) {
      setInputValue(card.nickname || '');
    }
  }, [card?.nickname]);

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">
        {t('cardinformation.title')}
      </h1>
      <IonContent className="ion-padding farecards-info-content">
        <IonItem
          lines="none"
          className="pb-2 ion-pb-2 ion-text-center farecards-info-nickname-title"
        >
          <IonLabel class="no-translate" color="primary">
            {card?.nickname || formatCreditCard(card?.cardId)}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="farecards-info-key ion-no-padding">
          <IonLabel className="farecards-info-key-label">
            {t('cardinformation.infoNumber')}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="farecards-info-value ion-no-padding">
          <IonLabel color="primary" className="farecards-info-value-label">
            {formatCreditCard(card?.cardId)}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="farecards-info-key ion-no-padding">
          <IonLabel className="farecards-info-key-label">
            {t('cardinformation.infoType')}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="farecards-info-value ion-no-padding">
          <IonLabel color="primary" className="farecards-info-value-label">
            {card?.riderType}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="farecards-info-key ion-no-padding">
          <IonLabel className="farecards-info-key-label">
            {t('cardinformation.infoBalance')}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="farecards-info-value ion-no-padding">
          <IonLabel color="primary" className="farecards-info-value-label">
            {t('cardinformation.infoBalanceValue', {
              balance: currencyFormatNoSpace(card?.balance || 0),
            })}
          </IonLabel>
        </IonItem>

        <IonItemDivider
          mode={uiInputMode()}
          className="ion-margin-vertical farecards-info-divider"
        />

        <IonItem lines="none" className="ion-no-padding">
          <IonLabel className="farecards-info-key-label">
            {t('cardinformation.infoNickname')}
          </IonLabel>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding">
          <IonInput
            value={inputValue}
            onIonInput={(e) => setInputValue(e.detail.value!)}
            placeholder={t('cardinformation.infoNicknamePlaceholder') || ''}
            mode={uiInputMode()}
            type="text"
          />
        </IonItem>

        <div className="pt-3 ion-pt-3 ion-text-center">
          <IonButton
            className={
              'btn-default btn-wide-80 ' +
              (inputValue === card?.nickname ? 'btn-disabled' : '')
            }
            onClick={() => onSubmit(inputValue.trim())}
          >
            {t('cardinformation.infoButtonText')}
          </IonButton>
        </div>
      </IonContent>
    </>
  );
};

export default CardInformation;
